<template>
    <div style="background-image: url('/gfx/tlo-light.jpg')" class="bg-gray-100 bg-center bg-cover flex-grow flex flex-col items-center justify-center relative">
        <!-- Loader -->
        <div v-if="isLoading" class="bg-white bg-opacity-80 absolute top-0 left-0 z-10 w-full h-full flex items-center justify-center">
            <div class="loader"></div>
        </div>
        <div v-if="questions.length">
            <template v-if="summaryScreen">
                <!-- Summary screen -->
                <div class="text-center text-3xl font-bold mb-4 mx-4">Gratulacje</div>
                <div class="text-center text-lg mb-8 mx-4">
                    Udzieliłeś/aś <span class="text-green-700 font-bold">{{ points }} poprawnych odpowiedzi</span> w czasie
                    <span class="text-green-700 font-bold">{{ totalTime }} sekund</span>
                </div>
                <div class="max-w-lg mx-4">
                    <form @submit.prevent="save">
                        <div class="grid grid-cols-1 gap-y-7">
                            <div>
                                <div v-if="formError" class="block text-sm px-8 py-3 border border-red-600 bg-red-100 text-center text-red-600">
                                    {{ formError }}
                                </div>
                            </div>
                            <div class="relative">
                                <input
                                    v-model="nick"
                                    class="w-full h-12 rounded focus:outline-none focus:ring focus:ring-opacity-40"
                                    :class="[
                                        $v.nick.$dirty && $v.nick.$invalid
                                            ? 'border-red-500 focus:ring-red-200 focus:border-red-700'
                                            : 'focus:ring-green-700 focus:border-green-700',
                                    ]"
                                    type="text"
                                    name="Nick"
                                    placeholder="Twój nick"
                                    v-mask="'XXXXXXXXXX'"
                                    @blur="$v.nick.$touch()"
                                />
                                <div class="text-red-600 text-xs absolute -bottom-5 left-0 px-3">
                                    {{ $v.nick.$dirty && $v.nick.$invalid ? "Podaj swój nick" : "" }}
                                </div>
                            </div>
                            <div class="relative">
                                <input
                                    v-model="email"
                                    class="w-full h-12 rounded focus:outline-none focus:ring focus:ring-opacity-40"
                                    :class="[
                                        $v.email.$dirty && $v.email.$invalid
                                            ? 'border-red-500 focus:ring-red-200 focus:border-red-700'
                                            : 'focus:ring-green-700 focus:border-green-700',
                                    ]"
                                    type="email"
                                    name="Email"
                                    placeholder="E-mail"
                                    @blur="$v.email.$touch()"
                                />
                                <div class="text-red-600 text-xs absolute -bottom-5 left-0 px-3">
                                    {{ $v.email.$dirty && $v.email.$invalid ? "Podaj adres e-mail" : "" }}
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    key="saveButtonKey"
                                    class="block w-full text-sm uppercase px-6 h-12 bg-yellow-600 text-white rounded tracking-wider transition duration-500 hover:bg-yellow-700 focus:ring focus:ring-offset-2 focus:ring-yellow-700 focus:ring-opacity-20 cursor-pointer select-none focus:outline-none"
                                >
                                    Zapisz wynik
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </template>
            <template v-else-if="thankyou">
                <div class="text-center text-3xl font-bold mb-8">Dziękujemy za udział w konkursie</div>
                <div class="text-center">
                    <a href="/tablica-wynikow" class="inline-block text-sm uppercase px-6 py-3 bg-green-700 text-white rounded tracking-wider transition duration-500 hover:bg-green-800 focus:ring-1 focus:ring-offset-2 focus:ring-green-700 focus:ring-opacity-50">Zobacz wyniki</a>
                </div>
            </template>
            <template v-else>
                <!-- Start button -->
                <button
                    v-if="!isStarted && !isCompleted"
                    class="inline-block uppercase px-6 py-3 bg-yellow-600 text-white rounded tracking-wider transition duration-500 hover:bg-yellow-700 focus:ring focus:ring-offset-2 focus:ring-yellow-700 focus:ring-opacity-20 cursor-pointer select-none shadow focus:outline-none"
                    @click="start"
                >
                    Rozpocznij quiz
                </button>

                <!-- Question -->
                <div class="p-4" v-if="question">
                    <div class="text-2xl font-bold text-center mb-4">Pytanie {{ currentQuestionIndex + 1 }}</div>
                    <div style="height: 4px;" class="bg-gray-200 w-full md:w-card max-w-full mx-auto rounded mb-4">
                        <div class="bg-blue-600 h-full" :style="'width:' + (timeLimit * 100) / 10 + '%'"></div>
                    </div>
                    <div
                        class="bg-white w-full mb-8 max-w-full rounded-xl shadow-xl py-20 px-16 mx-auto flex items-center justify-center md:w-card md:min-h-card"
                    >
                        <div class="text-center text-xl font-bold" :class="correctAnswer ? 'text-red-600' : 'text-black'">{{ question }}</div>
                    </div>
                    <div class="flex flex-wrap items-center justify-center mb-8">
                        <button
                            key="answerAKey"
                            v-if="answerA"
                            class="btn-quiz w-full sm:w-auto"
                            :class="{ 'btn-quiz--selected': currentAnswer == 'A', 'btn-quiz--invalid': correctAnswer == 'A' }"
                            @click="check('A')"
                        >
                            {{ answerA }}
                        </button>
                        <button
                            key="answerBKey"
                            v-if="answerB"
                            class="btn-quiz w-full sm:w-auto"
                            :class="{ 'btn-quiz--selected': currentAnswer == 'B', 'btn-quiz--invalid': correctAnswer == 'B' }"
                            @click="check('B')"
                        >
                            {{ answerB }}
                        </button>
                        <button
                            key="answerCKey"
                            v-if="answerC"
                            class="btn-quiz w-full sm:w-auto"
                            :class="{ 'btn-quiz--selected': currentAnswer == 'C', 'btn-quiz--invalid': correctAnswer == 'C' }"
                            @click="check('C')"
                        >
                            {{ answerC }}
                        </button>
                        <button
                            key="answerDKey"
                            v-if="answerD"
                            class="btn-quiz w-full sm:w-auto"
                            :class="{ 'btn-quiz--selected': currentAnswer == 'D', 'btn-quiz--invalid': correctAnswer == 'D' }"
                            @click="check('D')"
                        >
                            {{ answerD }}
                        </button>
                    </div>
                    <div class="text-center">
                        <button
                            v-if="correctAnswer"
                            class="inline-block mx-2 text-sm px-6 py-3 border border-gray-600 text-gray-600 rounded tracking-wider transition duration-500 hover:bg-gray-600 hover:text-white focus:outline-none"
                            @click="restart"
                        >
                            Spróbuj ponownie
                        </button>
                        <button
                            v-if="correctAnswer && points > 0"
                            class="inline-block mx-2 text-sm px-6 py-3 border border-gray-600 text-gray-600 rounded tracking-wider transition duration-500 hover:bg-gray-600 hover:text-white focus:outline-none"
                            @click="summaryScreen = true"
                        >
                            Zapisz wynik
                        </button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
    name: "Quiz",
    props: ["recaptcha", "sitekey"],
    data() {
        return {
            questions: [],
            currentQuestionIndex: -1,
            currentAnswer: null,
            points: 0,
            totalTime: 0,
            timeLimit: 10,
            isCompleted: false,
            isStarted: false,
            correctAnswer: null,
            nick: "",
            email: "",
            g_recaptcha_response: "",
            isFetching: false,
            summaryScreen: false,
            counter: null,
            isSaving: false,
            formError: "",
            thankyou: false
        };
    },
    computed: {
        isLoading() {
            return this.isFetching || this.isSaving;
        },
        question() {
            return this.currentQuestionIndex > -1 ? this.questions[this.currentQuestionIndex].Name : "";
        },
        answerA() {
            return this.currentQuestionIndex > -1 ? this.questions[this.currentQuestionIndex].AnswerA : "";
        },
        answerB() {
            return this.currentQuestionIndex > -1 ? this.questions[this.currentQuestionIndex].AnswerB : "";
        },
        answerC() {
            return this.currentQuestionIndex > -1 ? this.questions[this.currentQuestionIndex].AnswerC : "";
        },
        answerD() {
            return this.currentQuestionIndex > -1 ? this.questions[this.currentQuestionIndex].AnswerD : "";
        },
    },
    methods: {
        async fetch() {
            this.isFetching = true;
            try {
                const { data } = await this.$http.post("quiz/fetch");
                this.questions = data.questions;
            } catch (error) {
                console.error(error);
            }
            this.isFetching = false;
            this.isLoaded = true;
        },
        async save() {
            if (!this.isSaving) {
                this.formError = "";
                this.isSaving = true;
                try {
                    this.$v.$touch();
                    if (!this.$v.$invalid) {
                        const formData = new FormData();
                        formData.append("nick", this.nick);
                        formData.append("email", this.email);
                        formData.append("points", this.points);
                        formData.append("seconds", this.totalTime);
                        formData.append("g_recaptcha_response", this.g_recaptcha_response);
                        const { data } = await this.$http.post("quiz/save", formData, {
                            headers: {
                                "content-type": "multipart/form-data",
                            },
                        });
                        if (!data.isError) {
                            this.exit();
                            this.thankyou = true;
                        } else {
                            this.formError = data.message;
                        }
                    } else {
                        console.log("sdfs");
                        this.formError = "Popraw błędy w formularzu";
                    }
                } catch (error) {
                    console.error = error;
                }
                this.isSaving = false;
            }
        },
        start() {
            this.isStarted = true;
            this.currentQuestionIndex = 0;
            this.countdown();
        },
        countdown() {
            if (!this.currentAnswer) {
                this.timeLimit = this.timeLimit - 0.01;
                if (this.timeLimit > 0) {
                    setTimeout(this.countdown, 10);
                } else {
                    this.check("");
                }
            }
        },
        async check(answer) {
            if (!this.currentAnswer && !this.isCompleted) {
                this.isFetching = true;
                this.currentAnswer = answer;
                try {
                    const formData = new FormData();
                    formData.append("id", this.questions[this.currentQuestionIndex].Id);
                    const { data } = await this.$http.post("quiz/check", formData, {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    });
                    if (data.correctAnswer) {
                        if (data.correctAnswer == answer) {
                            this.next();
                        } else {
                            this.stop(data.correctAnswer);
                        }
                    } else {
                        this.abort();
                    }
                } catch (error) {
                    console.error(error);
                }
                this.isFetching = false;
            }
        },
        next() {
            this.points += 1;
            this.totalTime += 10 - Math.abs(Math.round(this.timeLimit));
            this.currentAnswer = null;
            if (this.currentQuestionIndex + 1 < this.questions.length) {
                this.currentQuestionIndex += 1;
                this.timeLimit = 10;
                this.countdown();
            } else {
                this.isCompleted = true;
                this.summaryScreen = true;
            }
        },
        stop(correctAnswer) {
            this.correctAnswer = correctAnswer;
            this.isCompleted = true;
        },
        restart() {
            this.fetch();
            this.currentQuestionIndex = 0;
            this.currentAnswer = null;
            this.points = 0;
            this.totalTime = 0;
            this.timeLimit = 10;
            this.isCompleted = false;
            this.correctAnswer = null;
            this.countdown();
        },
        exit() {
            this.fetch();
            this.currentQuestionIndex = -1;
            this.currentAnswer = null;
            this.points = 0;
            this.totalTime = 0;
            this.timeLimit = 10;
            this.isCompleted = false;
            this.isStarted = false;
            this.correctAnswer = null;
            this.nick = "";
            this.email = "";
            this.isFetching = false;
            this.summaryScreen = false;
        },
    },
    created() {
        this.fetch();
        if (this.recaptcha) {
            const that = this;
            grecaptcha.ready(function () {
                grecaptcha
                    .execute(`${that.sitekey}`, {
                        action: "homepage",
                    })
                    .then(function (token) {
                        that.g_recaptcha_response = token;
                    });
            });
        }
    },
    validations: {
        nick: {
            required,
        },
        email: {
            required,
            email,
        },
    },
};
</script>

<style>
</style>